export const GENERAL = {
    V_CORTESIA: {
        FindProductionOrdersForAppointments: 'Services/Workshop/RepairOrderService.svc/FindProductionOrdersForAppointments',
        FindAppointmentRegistryInDates: 'Services/General/AppointmentsService.svc/FindAppointmentRegistryInDates',
        GetAppointmentRegistryById: 'Services/General/AppointmentsService.svc/GetAppointmentRegistryById',
        GetReplacementCarsFree: 'Services/General/AppointmentsService.svc/GetReplacementCarsFreeForPeriodDates',
        GetAppointmentCarRegistryById: 'Services/General/AppointmentsService.svc/GetAppointmentCarRegistryById',
        AddAppointmentCarRegistry: 'Services/General/AppointmentsService.svc/AddAppointmentCarRegistry',
        DeleteAllAppointmentCarDataByID: 'Services/General/AppointmentsService.svc/DeleteAllAppointmentCarDataByID',
        UpdateAppointmentCarRegistry: 'Services/General/AppointmentsService.svc/UpdateAppointmentCarRegistry',
        AddAppointmentCarDriver: 'Services/General/AppointmentsService.svc/AddAppointmentCarDriver',
        UpdateAppointmentCarDriver: 'Services/General/AppointmentsService.svc/UpdateAppointmentCarDriver',
        FindInsuranceCompanies: 'Services/General/CustomerService.svc/FindInsuranceCompanies',
        AddAppointmentCarInsurance: 'Services/General/AppointmentsService.svc/AddAppointmentCarInsurance',
        UpdateAppointmentCarInsurance: 'Services/General/AppointmentsService.svc/UpdateAppointmentCarInsurance',
        AddAppointmentCarDetail: 'Services/General/AppointmentsService.svc/AddAppointmentCarDetail',
        UpdateAppointmentCarDetail: 'Services/General/AppointmentsService.svc/UpdateAppointmentCarDetail',
        FindAppointmentCarRegistryInDates: 'Services/General/AppointmentsService.svc/FindAppointmentCarRegistryInDates',
        GetByProductionOrderNumberComplete: 'Services/Workshop/RepairOrderService.svc/GetByProductionOrderNumberComplete',
        CalendarsService: 'Services/General/CalendarsService.svc/GetAll'

    }
}


